var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { BasketItemType } from "@irati/types";
import basket from "@irati/checkout/utils/basket";
import BirthdayBoxSelection from "../../../components/ProductForms/BirthdayBoxSelection";
var BirthdayBoxProduct = /** @class */ (function (_super) {
    __extends(BirthdayBoxProduct, _super);
    function BirthdayBoxProduct() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedProductId: null
        };
        _this.selectProduct = function (productUuid) {
            var selectedProduct = _this.props.products.find(function (t) { return t.productId === productUuid; });
            basket.clear();
            if (selectedProduct) {
                _this.setState({ selectedProductId: selectedProduct.productId });
                var productId = selectedProduct.productId, linkProduct = selectedProduct.linkProduct;
                basket.setProduct(BasketItemType.Deal, _this.props.deal.uuid, productId, { count: 1 });
                basket.setProduct(BasketItemType.Deal, _this.props.deal.uuid, linkProduct, { count: 1 });
            }
            else {
                _this.setState({ selectedProductId: null });
            }
        };
        return _this;
    }
    BirthdayBoxProduct.prototype.render = function () {
        return (React.createElement(BirthdayBoxSelection, { onChange: this.selectProduct, deal: this.props.deal, value: this.state.selectedProductId, options: this.props.products }));
    };
    return BirthdayBoxProduct;
}(PureComponent));
export default BirthdayBoxProduct;
